export default ({ newsletters_landing, subscription }, _, { t }) => {
  if (newsletters_landing) {
    return t(`newsletter_landing_page_meta_description_${subscription}`);
  }
};
